module.exports = __webpack_public_path__ + "img/BadRagaz_Quellenhof_3.jpg";